import { uniq } from 'lodash'

// return name, uuid and children of revenue centers. Children are menus assigned to particular revenue center
export const getRevenueCentersWithMenus = (
  allMenus,
  allRevenueCenters
) => {
  // get all id's of revenue center that are in menus
  const allRevenueCentersAssignedToMenusIds = allMenus?.map(
    ({ standId }) => standId
  )

  // remove ids duplicates
  const uniqueRevenueCentersIds = uniq(
    allRevenueCentersAssignedToMenusIds
  )

  // return revenue ceters assigned to menus
  const allRevenueCentersAssignedToMenus = allRevenueCenters?.filter(
    ({ id }) => uniqueRevenueCentersIds?.includes(id)
  )

  // return revenue centers and menus assigned to each revenue center
  const revenueCentersAndMenus =
    allRevenueCentersAssignedToMenus?.reduce((acc, revenueCenter) => {
      // get menus assigned to current revenue center
      const menusAssignedToRevenueCenter = allMenus?.filter(
        ({ standId }) => standId === revenueCenter?.id
      )

      // transform menus to return name and uuid
      const transformedMenus =
        menusAssignedToRevenueCenter?.map(({ name, uuid }) => {
          return {
            name,
            uuid,
          }
        }) ?? []

      // return all revenue centers and transformed menus as child of each revenue center
      return [
        ...acc,
        {
          name: revenueCenter?.name,
          uuid: `revenue-center-${revenueCenter?.id}`,
          menus: transformedMenus ?? [],
        },
      ]
    }, [])

  return revenueCentersAndMenus ?? []
}
